export const FETCH_SERIE_CHAPTER_REQUEST = "FETCH_SERIE_CHAPTER_REQUEST";
export const FETCH_SERIE_CHAPTER_SUCCESS = "FETCH_SERIE_CHAPTER_SUCCESS";
export const FETCH_SERIE_CHAPTER_FAILURE = "FETCH_SERIE_CHAPTER_FAILURE";